import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import spBanner from "../images/smart-1.png";
import spBig from "../images/smart-2.png";
import spCollage from "../images/smart-3.png";

import {
  FaTv,
  FaChalkboardTeacher,
  FaUsers,
  FaBrain,
  FaTools,
  FaShieldAlt
} from "react-icons/fa";

function SmartPanels() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sidebar = [
    { title: "Interactive Smart Panels", icon: FaTv },
    { title: "Teacher-Friendly Digital Teaching", icon: FaChalkboardTeacher },
    { title: "Improved Student Engagement", icon: FaUsers },
    { title: "Better Conceptual Understanding", icon: FaBrain },
    { title: "Quick Installation & Training", icon: FaTools },
    { title: "Warranty & Support", icon: FaShieldAlt },
  ];

  const features = [
    "Touch-enabled interactive displays",
    "Multimedia-rich digital classrooms",
    "Live annotations & screen sharing",
    "Teacher training & onboarding",
    "On-site installation & support",
  ];

  return (
    <ServiceTemplate
      title="INTERACTIVE SMART PANELS"
      bannerImage={spBanner}
      bigImage={spBig}
      collageImage={spCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}

export default SmartPanels;
